import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import { compile } from "@bd-utils/handlerbars-helper";
// @ts-ignore
//const jsPDF = window.jspdf.jsPDF;
//import html2canvas from "html2canvas";

export class Block_Result_Preference extends BD_Block {
  constructor() {
    super();

    this.type = "result_preference";
    this.templateID = "result-preference";
    this._serverSide = true;

    this.elms = {
      finishButton: "#finishButton",
      pdfButton: "#pdfButton",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.audio = false;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.finishButton,
        handler: this.onFinish,
      },
      {
        event: "click",
        selector: elms.pdfButton,
        handler: this.downloadPDF,
      },
    ];
  }

  beforeInit() {
		const blockParamID = this.getUrlParameter("blockID");

    if(blockParamID) return;
    this.render();
    this.setGameState();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();

    bdapi
      .post("game/get-results-preference")
      .then((res) => {
        const resData = res.data;
        const data = resData.data;

        const resultAndData = { ...data, ...this._data };
        const html = compile(htmlTemplate, resultAndData);

        $("#templateWrapper").html(html);

        bdjs.hideLoading();
      })
      .catch(() => {});
  }

  setGameState() {}

  /* ========= ELEMENT FUNCTION HANDLER ===============*/

  onFinish(e, $el) {
    $el.addClass("is-loading").prop("disabled", true);

    bdapi
      .post("member/reset-active-game-progress", {})
      .then(() => {
        bdjs.showLoading(() => window.location.reload());
      })
      .catch(() => {
        $el.removeClass("is-loading").prop("disabled", false);
      });
  }

  downloadPDF() {
    return;
    /*const profile = document.getElementById("preferenceProfile");

        html2canvas(profile, { scale: 2, backgroundColor: "#053D63" }).then(
            (canvas) => {
                const profileData = canvas.toDataURL("img/png");
                const pdf = new jsPDF("p", "mm", "a4");
                const imgProps = pdf.getImageProperties(profileData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                const defaultHeight = pdf.internal.pageSize.getHeight();
                pdf.setFillColor(5, 61, 99);
                pdf.rect(0, 0, pdfWidth, defaultHeight, "F");
                pdf.addImage(profileData, "PNG", 0, 0, pdfWidth, pdfHeight);
                pdf.save("profile.pdf");
            },
        );

        $(this.elms.finishButton).prop("disabled", false);*/
  }

  getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;
	
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
	
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
		}
		return false;
	}
}
